// @ts-ignore
import * as React from 'react';
import {useEffect} from 'react'

import './index.less'
import PracticeHeaderImage from '../../../assets/images/cy/practice_header.png'
import PracticeLaboratoryPanel from "../panels/PracticeLaboratoryPanel";

const clsPrefix = 'cy-practice'

const PracticePage: React.FC = () => {
    useEffect(() => {
        createComment()
        // 统计
        pvStat()
    })

    function pvStat () {
        // 统计 体验页 页面流量
        if (window) {
            // 用 stat-portrait
            // @ts-ignore
            window.xqui.useStat({
                action: 'enter',
                category: '',
                bizType: 5,
                page: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_practice_page`
            })
        }
    }

    const createComment = () => {
        const target = document.querySelector('#PC_COMMENT');
        const container = document.createElement('div')
        container.id = 'SOHUCS'
        container.setAttribute('sid', 'pccode')
        const script = document.createElement('script')
        script.src = 'https://changyan.sohu.com/upload/changyan.js'
        script.onload = function () {
            // @ts-ignore
            window.changyan.api.config({
                appid: 'cyqARl5Jo',
                conf: 'prod_07871915a8107172b3b5dc15a6574ad3'
            });
        }
        target.appendChild(container)
        target.appendChild(script)
    }

    return (
    <div className={clsPrefix}>
        <div className={`${clsPrefix}__screen ${clsPrefix}__screen-one`}>
            <div className="header" >
                <img className="header-img" src={PracticeHeaderImage} />
            </div>
        </div>

        <div className={`${clsPrefix}__screen ${clsPrefix}__screen-two`} >
            <div className={`${clsPrefix}__screen-two__title`}>畅言互动体验</div>
            <PracticeLaboratoryPanel isInScreen={true}></PracticeLaboratoryPanel>
        </div>

        <div className={`${clsPrefix}__screen ${clsPrefix}__screen-three`} >
            <div className={`${clsPrefix}__screen-three__comment`} id="PC_COMMENT">
        </div>
        </div>
    </div>
)
}

export default PracticePage;